import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { Controller, Form, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { Submit } from "../../../common/Button";
import {
  InwardAccepted,
  InwardManual,
} from "../../../../utils/apis/Mt_Inward/Inward";
import {
  formatDate,
  Select2BankData,
  Select2Data,
} from "../../../../utils/common";
import Pagination from "../../../common/Pagination";

import ScreenShot from "../../../common/ScreenShot";
import { Context } from "../../../../utils/context";
import { getAllData, Delete } from "../../../../utils/apis/Mt_Inward/Inward";
// import DataTable from "react-data-table-component";
import { FaTrash } from "react-icons/fa";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "../../../common/common-offcanvas/Filter_offcanvas";
import { ShimmerButton, ShimmerTable } from "react-shimmer-effects";
import { Banks, getSetup, State } from "../../../../utils/apis/masters/masters";
import Select from "react-select"; // ✅ default export
import { Button, Col, Container, Modal, Row } from "react-bootstrap";

export const Investor = ({
  status,
  setStatus,
  handleExportCSV,
  handlePrint,
  handleExportExcel,
  isAllow,
  convertrate,
}) => {
  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setError,
    reset,
    control,
    setValue,
  } = useForm();

  const onSubmit = (data) => {
    // console.log(data);
    // alert(JSON.stringify(data));
  };

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [TotalEntries, setTotalEntries] = useState(1);
  const [TotalPages, setTotalPages] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);

  const getData = async () => {
    setShimmerLoader(true);
    let res;
    res = await getAllData(
      currentPage,
      perPage,
      getValues("contact"),
      getValues("name"),
      getValues("from"),
      getValues("to"),
      getValues("state_id")?.value,
      getValues("city_id")?.value,
      getValues("bank_account_id")?.value,
    );

    await setData(res.data);
    await setCurrentPage(res?.data?.currentPage);
    await setperPage(res?.data?.per_page);
    await setTotalEntries(res?.data?.totalEntries);
    await setTotalPages(res?.data?.totalPages);

    setShimmerLoader(false);
  };

  useEffect(() => {
    getData();
  }, [perPage, currentPage]);

  const Accepted = async (id) => {
    const amount = getValues(`amount_${id}`);

    const bank_account_id = getValues(`bank_${id}`);

    if (!bank_account_id) {
      await setError(`bank_${id}`, {
        type: "manual",
        message: "Select bank Account",
      });
    }
    const data = {
      amount: amount,
      id: id,
      bank_account_id: bank_account_id,
    };
    // console.log(bank_account_id, "bank");

    if (amount > 0) {
      const res = await InwardManual(data);
      if (res.success) {
        getData();
        setStatus(res.success);
      }
      // getData();
      // Proceed with your logic here
    } else {
      await setError(`amount_${id}`, {
        type: "manual",
        message: "Enter amount",
      });
    }
  };

  const SegamentDelete = async (id) => {
    const res = await Delete(id);
    setShowModal(false);
    getData();
  };

  const [modalShow2, setModalShow2] = React.useState(false);

  const [banks, setBanks] = useState([]);

  const getMastersData = async () => {
    {
      const res = await Banks();
      await setBanks(await Select2BankData(res?.data, "bank_account_id"));
    }
  };
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    getMastersData();
  }, []);

  // const [setup, setSetup] = useState({});
  // const getsetup = async () => {
  //   const res = await getSetup();
  //   await setSetup(res?.data);
  // };

  // useEffect(() => {
  //   getsetup();
  // }, []);
  // const convertrate = (amount) => {
  //   const inr = Number(amount);
  //   const rate = Number(setup.deposite_exchange_rate);
  //   const total = (inr * rate).toFixed(2);
  //   return total;
  // };

  return (
    <div className="search-investor mt-3">
      <div className="investor-main">
        <div>
          <p className="sub">
            <FontAwesomeIcon icon="fa-solid fa-location-dot" className="me-3" />
            Investor
          </p>
        </div>

        <div className="filterdiv">
          <button onClick={() => setModalShow2(true)} className="filterbtn">
            <FontAwesomeIcon icon={faFilter} />
            &nbsp;Filter
          </button>
        </div>
      </div>

      <div className="inward-payment">
        <div className="nav-link active">
          {/* <div className="dt-buttons btn-group flex-wrap">
            <button
              className="btn btn-secondary buttons-excel buttons-html5 ml-1 Excel_btn"
              tabindex="0"
              aria-controls="DataTables_Table_0"
              type="button"
              onClick={() => handleExportExcel(data, "Investor")}
            >
              <span>Excel</span>
            </button>
            <button
              className="btn btn-secondary buttons-csv buttons-html5 CSV_btn"
              tabindex="0"
              aria-controls="DataTables_Table_0"
              type="button"
              onClick={() => handleExportCSV(data, "Investor")}
            >
              <span>CSV</span>
            </button>
            <button
              className="btn btn-secondary buttons-print Print_btn"
              tabindex="0"
              aria-controls="DataTables_Table_0"
              type="button"
              onClick={() => handlePrint(data, "Investor")}
            >
              <span>Print</span>
            </button>
          </div> */}
        </div>
      </div>
      {/* table started */}
      <div className="table-main">
        <div className="table-responsive mt-2">
          {/* <DataTable columns={columns} data={data?.data || []}  /> */}
          <form onSubmit={handleSubmit(onSubmit)}>
            {shimmerLoader ? (
              <>
                <ShimmerTable row={2} col={9} width={100} />
              </>
            ) : (
              <table className="table table-bordered  table-striped">
                <thead>
                  <tr>
                    <th className="name">
                      Payment Date
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>
                    <th className="name">
                      Investor Name
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>
                    <th className="name">
                      Service No
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>
                    <th className="name">
                      UTR No
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>

                    <th className="name">
                      Screenshot
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>
                    <th className="name">
                      Amount
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>

                    {/* <th className="name">
                      Bank Account
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>
                    <th className="name">
                      Action
                      <div className="triangle"></div>
                      <div className="triangle2"></div>
                    </th>  */}
                  </tr>
                </thead>

                <tbody>
                  {data?.length > 0 ? (
                    data?.map((data, index) => (
                      <tr className="odd" key={index}>
                        <td>{formatDate(data?.createdAt)}</td>
                        <td>
                          {data?.user?.f_name} {data?.user?.l_name}
                        </td>
                        <td>{data?.user?.contact_no}</td>
                        <td>{data?.utr_id}</td>
                        <td>
                          <button
                            className="btn btn-info"
                            type="button"
                            onClick={() => setShowModal(data?.id)}
                          >
                            View / Edit Payment
                          </button>

                          <Modal
                            show={showModal === data?.id}
                            onHide={() => setShowModal(false)}
                            centered
                            size="lg"
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Payment Details</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                              <Container>
                                {/* Screenshot */}
                                <div className="text-center mb-4">
                                  <img
                                    src={IMG_URL + data?.screenshot}
                                    alt="Screenshot"
                                    style={{
                                      width: "40%",
                                      maxHeight: "50vh",
                                      objectFit: "contain",
                                      borderRadius: "8px",
                                      boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                                    }}
                                  />
                                </div>

                                <Row className="g-3 align-items-end">
                                  <Col md={3}>
                                    <div className="form-group me-2">
                                      <sub>$ Amount</sub>
                                      <input
                                        type="number"
                                        placeholder="Amount"
                                        {...register(`amount_${data.id}`, {})}
                                        className={`form-control ${
                                          errors[`amount_${data.id}`]
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        defaultValue={data?.amount}
                                        // defaultValue={convertrate(data?.amount)}
                                      />
                                      <label>
                                        ₹ {convertrate(data?.amount)}
                                      </label>
                                    </div>
                                  </Col>

                                  <Col md={5}>
                                    {/* {data.upi_id !== null && (
                                      <span>UPI ID:- {data?.upi_id}</span>
                                    )} */}

                                    {/* <div className="form-group me-2">
                                      <Controller
                                        name={`bank_${data.id}`}
                                        control={control}
                                        rules={{ required: "Bank is required" }}
                                        render={({ field }) => (
                                          <Select
                                            styles={{
                                              control: (baseStyles) => ({
                                                ...baseStyles,
                                              }),
                                            }}
                                            classNamePrefix="custom-select-class"
                                            placeholder="Bank Account"
                                            options={banks}
                                            value={
                                              banks.find(
                                                (option) =>
                                                  option.value ===
                                                  data.bank_account_id
                                              ) || null
                                            } // ✅ Preselect the correct option
                                            onChange={(selectedOption) => {
                                              field.onChange(
                                                selectedOption?.value || null
                                              );
                                              setValue(
                                                `bank_${data.id}`,
                                                selectedOption?.value || null
                                              );
                                            }}
                                          />
                                        )}
                                      />
                                    </div> */}

                                    <div className="form-group me-2">
                                      <Controller
                                        name={`bank_${data.id}`}
                                        control={control}
                                        rules={{ required: "Bank is required" }}
                                        render={({ field }) => (
                                          <Select
                                            styles={{
                                              control: (baseStyles) => ({
                                                ...baseStyles,
                                              }),
                                            }}
                                            classNamePrefix="custom-select-class"
                                            placeholder="Bank Account"
                                            options={banks}
                                            // ✅ FIX HERE
                                            value={
                                              banks.find(
                                                (option) =>
                                                  option.value === field.value,
                                              ) || null
                                            }
                                            onChange={(selectedOption) => {
                                              field.onChange(
                                                selectedOption?.value || null,
                                              );
                                            }}
                                          />
                                        )}
                                      />
                                    </div>
                                  </Col>

                                  <Col md={4} className="text-center d-flex">
                                    {isAllow?.includes(37) && (
                                      <Button
                                        variant="success"
                                        className="w-80 me-2"
                                        onClick={() => Accepted(data.id)}
                                      >
                                        Add Amount
                                      </Button>
                                    )}
                                    {isAllow?.includes(38) && (
                                      <Button
                                        variant="danger"
                                        className="w-20"
                                        onClick={() => SegamentDelete(data.id)}
                                      >
                                        <FaTrash />
                                      </Button>
                                    )}
                                  </Col>
                                </Row>
                              </Container>
                            </Modal.Body>
                          </Modal>
                        </td>

                        <td>
                          <div className="form-group me-2">
                            ₹ {convertrate(data?.amount)}
                          </div>
                        </td>

                        {/* <td>
                          {data.upi_id !== null && (
                            <span>UPI ID:- {data?.upi_id}</span>
                          )}

                          <div className="form-group me-2">
                            <Controller
                              name={`bank_${data.id}`}
                              control={control}
                              rules={{ required: "Bank is required" }}
                              render={({ field }) => (
                                <Select
                                  styles={{
                                    control: (baseStyles) => ({
                                      ...baseStyles,
                                    }),
                                  }}
                                  classNamePrefix="custom-select-class"
                                  placeholder="Bank Account"
                                  options={banks}
                                  value={
                                    banks.find(
                                      (option) =>
                                        option.value === data.bank_account_id
                                    ) || null
                                  } // ✅ Preselect the correct option
                                  onChange={(selectedOption) => {
                                    field.onChange(
                                      selectedOption?.value || null
                                    );
                                    setValue(
                                      `bank_${data.id}`,
                                      selectedOption?.value || null
                                    );
                                  }}
                                />
                              )}
                            />
                          </div>
                        </td>
                        <td>
                          {isAllow?.includes(37) ? (
                            <button
                              onClick={() => {
                                Accepted(data.id);
                              }}
                              type="button"
                              className="btn btn-primary"
                            >
                              Add Amount
                            </button>
                          ) : (
                            <></>
                          )}
                          {isAllow?.includes(38) ? (
                            <button
                              onClick={() => {
                                SegamentDelete(data.id);
                              }}
                              type="button"
                              className="btn btn-danger"
                              style={{ marginLeft: "10px" }}
                            >
                              <FaTrash />
                            </button>
                          ) : (
                            <></>
                          )}
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <div>No Data Found</div>
                  )}
                </tbody>
              </table>
            )}
          </form>
        </div>
      </div>

      <ScreenShot show={modalShow} onHide={() => setModalShow(false)} />

      {["end"].map((placement, idx) => (
        <Filter_offcanvas
          placement={placement}
          key={idx}
          show={modalShow2}
          onHide={() => setModalShow2(false)}
          setValue={setValue}
          getValues={getValues}
          getData={getData}
          register={register}
          reset={reset}
          control={control}
        />
      ))}
    </div>
  );
};
